<template>
  <v-col lg12>
    <v-form ref="memberForm" name="memberForm">
      <v-col column wrap>
        <FileInput @file-selected="imageSelected" :url="member.image.url"></FileInput>
        <v-col lg12>
          <v-text-field
            v-model="member.name"
            label="Имя"
            name="name"
            :rules="[(v) => !!v || 'Это поле обязательно']"
          ></v-text-field>
        </v-col>
        <v-col lg12>
          <v-text-field
            v-model="member.post"
            label="Должность"
            name="post"
            :rules="[(v) => !!v || 'Это поле обязательно']"
          ></v-text-field>
        </v-col>
        <v-col lg12>
          <v-text-field v-model="member.class" label="Классификация" name="class"></v-text-field>
        </v-col>
        <v-col>
          <v-row row>
            <v-col lg6>
              <v-text-field
                v-model="member.contact"
                label="Телефон"
                name="contact"
                :rules="[(v) => !!v || 'Это поле обязательно']"
              ></v-text-field>
            </v-col>
            <v-col lg6>
              <v-text-field v-model="member.email" label="Email" name="email"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg12>
          <SiteSelect
            :site="member.site_key || $attrs.site_key"
            @site-selected="siteSelected"
          ></SiteSelect>
        </v-col>

        <v-col>
          <v-combobox v-model="member.tags" multiple persistent-hint small-chips label="Тэги">
          </v-combobox>
        </v-col>
        <v-col lg12>
          <ckeditor
            :editor="ckeditor"
            v-model="member.description"
            :config="ckConfig"
            type="classic"
            :upload-adapter="UploadAdapter"
          >
          </ckeditor>
          <input
            type="text"
            style="display: none"
            name="description"
            required
            v-model="member.description"
          />
        </v-col>
        <FileInput
          :required="false"
          :url="member.report_url"
          field-name="report_file"
          label="Отчет"
          accept="application/pdf"
        ></FileInput>
      </v-col>
      <v-btn color="primary" @click="save">Сохранить</v-btn>
    </v-form>
  </v-col>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import FileInput from '@/components/FileInput'
import ckeditorMixin from '@/mixins/ckeditor'
import { isEmpty } from 'lodash'

export default {
  name: 'Member',
  components: { SiteSelect, FileInput },
  mixins: [ckeditorMixin],
  props: {
    isEdit: { type: Boolean, default: false },
    site: { type: String, default: '' },
  },
  data() {
    return {
      member: {
        name: '',
        post: '',
        group_id: null,
        image: { url: '' },
        description: '',
        site_key: '',
        contact: '',
        email: '',
        tags: [],
        report_url: '',
        report_file: '',
      },
    }
  },
  watch: {
    site(e) {
      if (!this.isEdit) {
        this.member.site_key = e
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getMemberData()
    }
    this.member.site_key = this.site
  },
  methods: {
    reportFileSelected(e) {
      this.member.report_file = e
    },
    imageSelected(e) {
      this.member.image = e
    },
    siteSelected(e) {
      this.member.site_key = e.key
    },
    getMemberData() {
      if (!this.isEdit) {
        return
      }
      this.axios({
        url: `/v1/members/${this.$route.params.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.member = resp.data
          this.$emit('memberUpdate', this.member)
        })
        .catch((err) => {
          this.$log.error('get member', err)
          this.showSnackbar(err.response.data, 'error')
        })
    },
    updateMember() {
      const d = new FormData(this.$refs.memberForm.$el)
      if (this.member.tags) {
        for (let i = 0; i < this.member.tags.length; i++) {
          let tag = `${this.member.tags[i]}`
          d.append('tags[]', tag)
        }
      }
      this.axios({
        url: `/v1/members/${this.member.id}`,
        method: 'patch',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.member = resp.data
          this.$emit('memberUpdate', this.member)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateMember()
        return
      }
      if (!this.$refs.memberForm.validate()) {
        this.$log.debug('form', this.$refs.form)
        this.showSnackbar('Заполните все поля', 'error')
        return
      }
      if (isEmpty(this.member.description)) {
        this.showSnackbar('Заполните описание (биографию)', 'error')
        return
      }
      const d = new FormData(this.$refs.memberForm.$el)
      for (let i = 0; i < this.member.tags.length; i++) {
        let tag = `${this.member.tags[i]}`
        d.append('tags[]', tag)
      }

      this.axios({
        url: '/v1/members',
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.member = resp.data
          this.$emit('memberUpdate', this.member)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
